import { numbersOnly } from "./utils";

interface IWhatsapp {
  message: string;
  phone: string;
}

export function whatsappShare({ message }: Pick<IWhatsapp, "message">) {
  const textWhatsapp = encodeURIComponent(message);
  const whatsappLink = `https://wa.me/?text=${textWhatsapp}`;
  window.open(whatsappLink, "_blank", "noopener,noreferrer");
}

export function whatsappMessage({ message, phone }: IWhatsapp) {
  const textWhatsapp = encodeURIComponent(message);
  const celPhone = numbersOnly(phone);
  const whatsappLink = `https://wa.me/+55${celPhone}?text=${textWhatsapp}`;
  window.open(whatsappLink, "_blank", "noopener,noreferrer");
}
